
const headers = [
    {
      label: 'หน่วยงาน',
      field: 'department',
    },
    {
      label: 'สิทธิ์',
      field: 'role',
    },
    {
      label: 'รายละเอียดสิทธิ์',
      // field: 'region',
      field: 'exclusive',
    },
    {
      label: 'จัดการสิทธิ์',
      field: 'action',
      tdClass: 'text-center',
    },
    {
      label: 'INFO',
      field: 'info',
    },
    
  ]

  export default headers